import axios from '@/helpers/axios';
import { custServiceApi, suspendUnsuspendApi, refitLineApi } from '@/helpers/apis';
import filterByExpiry from '../../../__mocks__/filterByExpiry.json';
import contractMock from '../../../__mocks__/replace-sim-mock.json';

export const getContractServiceNumbers = (reqData) => {
  const url = custServiceApi.GET_CONTRACT_SERVICE_NUMBERS;
  return axios.post(url, reqData);
};

export const CustomerServiceNumbersWithNetworkType = (reqData) => {
  const url = custServiceApi.GET_SVC_NOS_REPLACE_SIM;
  return axios.post(url, reqData);
};

export const getContractServiceNumbersForTerminateNumber = (reqData) => {
  const url = custServiceApi.GET_CONTRACT_SERVICE_NUMBERS_FOR_TERMINATE_NUMBERS;
  return axios.post(url, reqData);
};

export const getContractServiceNumbersForChangePlan = (reqData) => {
  const url = custServiceApi.GET_CONTRACT_SERVICE_NUMBERS_FOR_CHANGE_PLAN;
  return axios.post(url, reqData);
};

export const getContractPricePlans = (reqPayload) => {
  const url = custServiceApi.GET_PRODUCT_PRICEPLAN;
  return axios.post(url, reqPayload);
};

export const getRecontractEligibilityValues = () => {
  const url = custServiceApi.GET_RECONTRACT_ELIGIBILITY_VALUES;
  return axios.get(url);
};

export const getAddOnsExistingVasValues = (reqPayload) => {
  const url = custServiceApi.GET_ADDONS_EXISTING_VAS_VALUES;
  return axios.post(url, reqPayload);
};

export const getContactExpiryValues = () => {
  return Promise.resolve(contractMock.contractExpiry);
};

export const getExistingVas = (reqPayload) => {
  const url = custServiceApi.FETCH_EXISTING_VASES;
  return axios.post(url, reqPayload);
};

export const getFilterByExpiry = () => {
  return Promise.resolve(filterByExpiry);
};

export const getFilterBySimType = () => {
  return Promise.resolve(contractMock.simTypeFilter);
};

export const getSIMByActivation = (payload) => {
  const url = custServiceApi.GET_SIM_BY_ACTIVATION;
  return axios.post(url, payload);
};

export const getCeaseAddonsServiceNumbers = (payload) => {
  const url = custServiceApi.GET_SVC_NOS_CEASE_ADDONS;
  return axios.post(url, payload.payload);
};

export const getCeaseAddonsDetails = (payload) => {
  const url = custServiceApi.GET_SVC_NOS_DETAILS_CEASE_ADDONS;
  return axios.post(url, payload);
};

export const getSupendLineServiceNumbers = (payload) => {
  const url = suspendUnsuspendApi.SUSPEND_CUSTOMER_SERVICE_NUMBERS;
  return axios.post(url, payload);
};

export const getSupendLineServiceEligibility = (payload) => {
  const url = suspendUnsuspendApi.SUSPEND_CUSTOMER_SERVICE_NUMBERS_ELIGIBILITY;
  return axios.post(url, payload);
};

export const refitServiceNumber = (payload) => {
  const url = refitLineApi.REFIT_SERVICE_NUMBER;
  return axios.post(url, payload);
};
